// extracted by mini-css-extract-plugin
export default {"tooltip":"pT-z","arrow":"qT-z"};